import {NgModule} from '@angular/core';

import {SharedModule} from '@shared/shared.module';
import {NzDrawerModule} from 'ng-zorro-antd/drawer';
import {NzStepsModule} from 'ng-zorro-antd/steps';
import {NzListModule} from 'ng-zorro-antd/list';
import {NzResultModule} from 'ng-zorro-antd/result';
import {NzTableModule} from 'ng-zorro-antd/table';
import {NzCarouselModule} from 'ng-zorro-antd/carousel';
import {NzImageModule} from 'ng-zorro-antd/image';
import {NzDescriptionsModule} from 'ng-zorro-antd/descriptions';
import {NzDividerModule} from 'ng-zorro-antd/divider';
import {MomentModule} from 'ngx-moment';
import {NzAlertModule} from 'ng-zorro-antd/alert';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {PageNotFoundComponent} from '@shared/components/page-not-found/page-not-found.component';
import {NoDataPlaceholderComponent} from '@shared/components/no-data-placeholder/no-data-placeholder.component';
import {TrainModelComponent} from '@shared/components/train-model/train-model.component';
import {NzRadioModule} from 'ng-zorro-antd/radio';
import {NzCheckboxModule} from 'ng-zorro-antd/checkbox';
import {TrainingHistoryComponent} from './training-history/training-history.component';
import {NzCollapseComponent, NzCollapseModule} from 'ng-zorro-antd/collapse';
import {SimulateCarComponent} from './simulate-car/simulate-car.component';
import {CreateDatasetComponent} from './create-dataset/create-dataset.component';

@NgModule({
  entryComponents: [PageNotFoundComponent, TrainModelComponent, TrainingHistoryComponent],
  declarations: [PageNotFoundComponent, NoDataPlaceholderComponent, TrainModelComponent, TrainingHistoryComponent, SimulateCarComponent, CreateDatasetComponent],
  exports: [],
  imports: [
    SharedModule,
    FontAwesomeModule,
    MomentModule,
    NzDrawerModule,
    NzStepsModule,
    NzListModule,
    NzResultModule,
    NzTableModule,
    NzCarouselModule,
    NzImageModule,
    NzDescriptionsModule,
    NzDividerModule,
    NzAlertModule,
    NzRadioModule,
    NzCheckboxModule,
    NzCollapseModule
  ],
  providers: [NzCollapseComponent]
})
export class SharedComponentsModule {
}
